import React from 'react';

import {Feature} from 'molbio/feature-libraries/FeatureLibraryConstants';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface LibraryItemProps {
  feature: Feature;
}

function LibraryItem({feature}: LibraryItemProps): JSX.Element {
  return (
    <>
      <td>
        <input type="checkbox" className="checkbox-active" defaultChecked={feature.selected} />
      </td>
      <td className="color">
        <div data-type="color" style={{backgroundColor: feature.color}} className="swatch editable-color" />
      </td>
      <td>
        <span data-type="name" className="text editable editable-text">
          {feature.name}
        </span>
      </td>
      <td>
        <span className="match_type">{feature.match_type}</span>
      </td>
      <td>
        <div data-type="feature_type" className="text editable editable-text">
          {feature.feature_type}
        </div>
      </td>
      <td>
        <div data-type="bases" className="text editable editable-text">
          {feature.bases}
        </div>
      </td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<LibraryItemProps>(LibraryItem);
